export default __webpack_public_path__ + "static/media/p2023-31.3166698f.jpeg";